import React from 'react';
import { MachineSetups } from '.';
import { MachineSetupContextProvider } from "./MachineSetupContextProvider";

export default function MachineSetupContainer () {
    return (
        <MachineSetupContextProvider>
            <MachineSetups/>
        </MachineSetupContextProvider>
    );
}